import React from 'react';
import { get } from 'lodash';

import TableHeader from './TableHeader';
import GenreFormModal from './GenreFormModal';
import ModalDelete from './ModalDelete';
import ImageLoader from './ImageLoader';
import PlatformDetails from './PlatformDetails';
import GiftModal from './GiftModal';

const GiftList = ({ gifts = [], total = 0 }) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Gifts</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} gifts</p>
        </div>

        <div className='MainHeader__right'>
          <GiftModal
            klassName='MainHeader__right__a MainHeader__right__a--bright-blue'
            label='Add Gift'
            title='Add Gift'
            reload
          />
        </div>
      </div>

      <div className='Table Table--gifts-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID'
            },
            {
              label: 'Order',
              sortKey: 'order'
            },
            {
              label: 'Name',
            },
            {
              label: 'Image'
            },
            {
              label: 'Inactive Image'
            },
            {
              label: 'Icon'
            },
            {
              label: 'Inactive Icon'
            },
            {
              label: 'Amount'
            },
            {
              label: 'Is Active'
            },
            {
              label: 'Gift Type'
            },
            {
              label: 'Manage'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {gifts.map((gift) => (
          <div className={'Table__row'} key={`gift_${gift.id}`}>
            <div className='Table__col'>{gift.id}</div>
            <div className='Table__col'>{gift.order}</div>
            <div className='Table__col'>{gift.name}</div>

            <div className='Table__col'>
              <ImageLoader url={gift.imageUrl} />
            </div>

            <div className='Table__col'>
              <ImageLoader url={gift.inactiveImageUrl} />
            </div>

            <div className='Table__col'>
              {console.log(gift)}
              <ImageLoader url={gift.iconUrl} />
            </div>

            <div className='Table__col'>
              <ImageLoader url={gift.inactiveIconUrl} />
            </div>

            <div className='Table__col'>
              {gift.amount}
            </div>

            <div className='Table__col'>
              {gift.isActive ?
                <span className='Badge'>Active</span>
              :
                <span className='Badge Badge--orange'>Inactive</span>
              }
            </div>

            <div className='Table__col'>
              {gift.giftType}
            </div>
            
            <div className='Table__col'>
              <div className='Table__controls'>
                <GiftModal
                  klassName='Table__controls__a Table__controls__a--pencil'
                  title='Edit Gift'
                  gift={gift}
                  reload
                />
                <ModalDelete
                  type='gift'
                  id={get(gift, 'id')}
                  klassName='Table__controls__a Table__controls__a--trash'
                  reload
                  hideText
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default GiftList
